import { Component, EventEmitter, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Provider } from 'src/app/models/administration/provider';
import { FuelOrder } from 'src/app/models/fuel/fuel-order';
import { DeleteGenericService } from 'src/app/services/delete-generic.service';
import { GeneratePdfFosilService } from 'src/app/services/generate-pdf-fosil.service';
import { NotificationsService } from 'src/app/services/notifications.service';
import { UtilsServiceService } from 'src/app/services/utils-service.service';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import {
  HeaderFilters,
  HttpService,
  LocalStorageService,
  MenuBreadCrumb,
  MessageService,
  params,
  SessionService,
  TableColumns,
  TableConfiguration,
} from 'brainloper-ui';

@Component({
    selector: 'app-fuel-order',
    templateUrl: './fuel-order.component.html',
    styleUrls: ['./fuel-order.component.scss'],
    standalone: false
})
export class FuelOrderComponent implements OnInit {
  public menuBreadCrumb: Array<MenuBreadCrumb> = [
    {
      name: 'Inicio',
      router: '/inicio',
    },
    {
      name: 'Orden de Combustible',
      current: true,
    },
  ];
  private urlComboEquipo: string = `${EndpointDictionary.Equipment.EQUIPMENT_COMBO}`;
  public urlTableFO: string = `${EndpointDictionary.HistoricalFuel.HISTORICAL_FUEL_TABLE}`;
  private urlPostFO: string = `${EndpointDictionary.HistoricalFuel.CRUD_HISTORICAL_FUEL_DATA}`;

  public params: params[] = [
    { id: 'equipmentId', value: '0' },
    { id: 'active', value: '1' },
  ];
  private size: number = 90;

  public titleFO: string = screen.width > 360 ? 'Orden Combustible' : 'O.F';
  public recargarTablaFO = new EventEmitter<any>();
  roleId:number
  public configurationFO: TableConfiguration = {
    edit: true,
    add: true,
    delete: true,
    selectable: false,
    addPer: true,
    editPer: true,
    primaryKey: 'id',
    print: true,
    closeOrder: true,
    sendEmail: true,
  };

  public columnasFO: TableColumns<FuelOrder>[] = [
    {
      ID: 'consecutive',
      label: '#',
      type: 'text',
      style: {
        textAlign: 'center',
        width: '80px',
        movil: 'no-movil',
      },
    },
    {
      ID: 'code',
      label: 'Código',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'requestsName',
      label: 'Solicita',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'place',
      label: 'Proveedor',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'date',
      label: 'Fecha',
      type: 'fecha',
      style: {
        textAlign: 'center',
      },
    },
  ];

  headerFilters: Array<HeaderFilters> = [
    {
      tN: 'equipos',
      labelFilter: 'Equipo',
      urlData: this.urlComboEquipo,
      visibleField: 'code',
      primaryKey: 'id',
      type: 'select',
      value: '',
    },
    {
      tN: 'historico_combustible',
      visibleField: 'fecha',
      type: 'date',
      value: '',
    },
    {
      tN: 'historico_combustible',
      visibleField: 'fecha',
      type: 'dateRange',
      value: '',
    },
  ];

  constructor(
    public dialog: MatDialog,
    private session: SessionService,
    private message: MessageService,
    private http: HttpService,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private generatePdf: GeneratePdfFosilService,
    private deleteItem: DeleteGenericService,
    private storage: LocalStorageService,
    private notificationsService: NotificationsService,
    private utils: UtilsServiceService
  ) {
    this.roleId = this.storage.get<number>('roleId')
  }

  ngOnInit(): void {
    if (screen.height > 830) {
      this.size = 70;
    }
  }

  agregarFO($event: FuelOrder) {
    this.session.setData('data', { action: 'add' });
    this.router.navigate(['detalle'], { relativeTo: this.activeRoute });
  }

  async editarFO($event: FuelOrder) {
    let res: boolean = await this.getDataFO($event[0].id);
    if (res) {
      this.router.navigate(['detalle'], { relativeTo: this.activeRoute });
    }
  }

  async getDataFO(id: number) {
    try {
      let res: Array<FuelOrder> = await this.http.getDataBody(
        `${this.urlPostFO}/${id}`
      );

      if (res) {
        this.session.setData('data', { action: 'edit', body: res });
        return true;
      }
    } catch (error) {
      this.message.Error('Error', error);
      return false;
    }
  }

  async eliminarFO($event: FuelOrder[]) {
    let res = await this.deleteItem.deleteD($event, this.urlPostFO, 'id');
    if (res) {
      let urlNotifications: Array<string> = [];
      for (const i of $event) {
        urlNotifications.push(
          `notificaciones/ordenCombustible?id_orden=${i.id}`
        );
      }
      this.notificationsService.deleteNotificationsByUrl(urlNotifications);
      this.recargarTablaFO.emit();
    } else {
      this.recargarTablaFO.emit();
    }
  }

  seleccionadosFO($event) {}

  async closeOrder($event: FuelOrder[]) {
    let url = this.utils.getQueryParams(
      `notificaciones/ordenCombustible?id_orden=${$event[0].id}`
    );
    setTimeout(() => {
      this.router.navigate([`${url.url}`], {
        queryParams: url.params,
      });
    }, 100);
  }

  async print($event: FuelOrder[]) {
    this.generatePdf.printTemplateFO($event[0].id);
  }

  async sendEmail($event: FuelOrder[]) {
    const providerEmail = $event[0]?.providerEmail;

    if (!providerEmail) {
        this.message.Info('Correo inválido', 'El correo del proveedor no es válido.');
        return;
    }

    const confirmationMessage = 'Confirmación de envío de correo';
    const userConfirmed = await this.message.Info(confirmationMessage, ``, true);

    if (!userConfirmed) {
        return;
    }

    try {
        this.message.openLoading('Cargando', 'Enviando correo');
        const emailData: Provider[] = await this.http.postDataBody(`${EndpointDictionary.HistoricalFuel.POST_EMAIL}`, $event[0]);

        if (emailData.length > 0) {
            const emailList = emailData.map(data => `[${data.providerName} - ${data.email}]`).join('\n');
            this.message.SuccessToast('¡Correo enviado con éxito!');
            console.log('Correos enviados a:\n' + emailList);
        }
    } catch (error) {
        this.message.Error('Error', 'No se pudo enviar el correo.');
        console.error(error);
    } finally {
        this.message.closeLoading();
    }
}
}
